<template>
    <div class="m-footer">
        <div class="wrapper">
            <div class="con-wrapper row">
                <div v-if="showLarger" class="row by-column">
                    <base-menu class="sub-menu left col-xs-4" :menu="sub_menu.first"></base-menu>
                    <base-menu class="sub-menu col-xs-4" :menu="sub_menu.second"></base-menu>
                    <base-menu class="sub-menu right col-xs-4" :menu="sub_menu.third"></base-menu>
                </div>
                <base-menu v-else class="sub-menu" :menu="sub_menu_small"></base-menu>
            </div>
        </div>
    </div>
</template>

<script>
    import BaseMenu from '@views/common/BaseMenu'
    import {checkNull} from '@/helpers'

    export default {
        name: 'm-footer',
        data() {
            return {
                sub_menu: {
                    first: [
                        { name: 'Support', route: 'support' },
                        { name: 'FAQ', route: 'faq' },
                    ],
                    second: [
                        { name: 'Cookies', route: 'cookie-policy' },
                        { name: 'terms', route: 'custom-page' },
                        { name: 'Privacy', route: 'custom-page' },
                    ],
                    third: [
                        { name: 'Blog', route: 'home' },
                        { name: 'Affiliates', route: window.APP_CONFIG.AFFILIATE_LINK, isExternal: true },
                    ]
                },
                sub_menu_small: [
                    { name: 'Blog', route: 'home' },
                    { name: 'Faq', route: 'faq' },
                    { name: 'Cookies', route: 'cookie-policy' },
                    { name: 'terms', route: 'custom-page' },
                    { name: 'Privacy', route: 'custom-page' },
                    { name: 'Affiliates', route: window.APP_CONFIG.AFFILIATE_LINK, isExternal: true },
                    { name: 'Support', route: 'support' },
                ],
                links: window.APP_CONFIG.LINKS,
            }
        },
        methods: {
            init_links() {
                this.sub_menu.second[0] = { name: 'Cookie Policy', route: this.$t('cookie-policy'), isBasic: true }
                this.sub_menu.second[1] = { name: 'terms', route: this.$t('terms-and-conditions'), isBasic: true }
                this.sub_menu.second[2] = { name: 'Privacy', route: this.$t('privacy'), isBasic: true }
                this.sub_menu_small[2] = { name: 'Cookie Policy', route: this.$t('cookie-policy'), isBasic: true }
                this.sub_menu_small[3] = { name: 'terms', route: this.$t('terms-and-conditions'), isBasic: true }
                this.sub_menu_small[4] = { name: 'Privacy', route: this.$t('privacy'), isBasic: true }

                this.links.forEach(val => {
                    if (val.name == 'blog') {
                        this.sub_menu.third[0] = {name: 'Blog', route: val.url || null, isExternal: true}
                        this.sub_menu_small[0] = {name: 'Blog', route: val.url || null, isExternal: true}
                    } else if(val.name == 'affiliates') {
                        this.sub_menu.third[1] = { name: 'Affiliates', route: window.APP_CONFIG.AFFILIATE_LINK || val.url , isExternal: true, hide: checkNull(val.hide) }
                        this.sub_menu_small[5] = { name: 'Affiliates', route: window.APP_CONFIG.AFFILIATE_LINK || val.url , isExternal: true, hide: checkNull(val.hide) }
                    } else if(val.name) {
                        let item = { name: val.name,  route: val.url, isBasic: true }
                        if(val.isExternal) {
                            item.isExternal = true
                            item.isBasic = false
                        }
                        this.sub_menu_small.push(item)
                        if(this.sub_menu.first.length > this.sub_menu.second.length) {
                            this.sub_menu.second.push(item)
                        } else if(this.sub_menu.second.length > this.sub_menu.third.length) {
                            this.sub_menu.third.push(item)
                        } else {
                            this.sub_menu.first.push(item)
                        }
                    }
                })

                if (!this.sub_menu_small[0].isExternal) {
                    this.sub_menu_small[0].hide = true
                }
                if (!this.sub_menu.third[0].isExternal) {
                    this.sub_menu.third[0].hide = true
                }

                //move affiliates and terms
                this.sub_menu.second.push(this.sub_menu.second.splice(0, 1)[0])
                this.sub_menu.third.push(this.sub_menu.third.splice(1, 1)[0])
                this.sub_menu_small.push(this.sub_menu_small.splice(5, 1)[0])
                this.sub_menu_small.push(this.sub_menu_small.splice(3, 1)[0])
            }
        },
        computed: {
            showLarger() {
                return this.$root.$children[0].width > 575
            },
            webcam_url() {
                return this.$store.getters['pub/webcamUrl'];
            }
        },
        created() {
            this.init_links()
        },
        components: {
            BaseMenu
        },
        watch: {
            webcam_url: {
                handler(v) {
                    const indexThird = this.sub_menu.third.findIndex(e => e.name === "Cams");
                    const indexSmall = this.sub_menu_small.findIndex(e => e.name === "Cams");
                    if(v && this.$store.getters['auth/isAuthenticated']) {
                        if (indexThird === -1) {
                            this.sub_menu.third.unshift({ name: 'Cams', action_name: 'redirectWebCamUrl', href: '/cams' })
                        }
                        if (indexSmall === -1) {
                            this.sub_menu_small.unshift({ name: 'Cams', action_name: 'redirectWebCamUrl', href: '/cams' })
                        }
                    } else  {
                        if (indexThird !== -1) {
                            this.$delete(this.sub_menu.third, indexThird);
                        }
                        if (indexSmall !== -1) {
                            this.$delete(this.sub_menu_small, indexSmall);
                        }
                    }
                },
                immediate: true
            }
        }
    }
</script>

<style lang="scss">
.m-footer {
    background: #000;
    .wrapper {
        padding: 20px 15px;
        color: #fff;
        border-top: 1px solid #fff;
        .sub-menu {
            display: flex;
            width: 100%;
            justify-content: center;
            align-items: center;
            ul {
                display: flex;
                flex-direction: column;
                li {
                    text-align: left;
                    text-transform: capitalize;
                    padding: 0;
                    font-size: 14px;
                    line-height: 1.8;
                    a {
                        padding: 0 8px;
                    }
                }
            }
        }
        .by-column {
            width: 100%;
            .sub-menu {
                align-items: baseline;
                ul {
                    display: flex;
                    flex-direction: column;
                    li {
                        text-align: center;
                    }
                }
                &.left {
                    justify-content: flex-start;
                    ul {
                        li {
                            text-align: left;
                        }
                    }
                }
                &.right {
                    justify-content: flex-end;
                    ul {
                        li {
                            text-align: right;
                        }
                    }
                }
            }
        }
    }
}
</style>
